import { CategoryLandingPageKey } from '@lambda/apis/src/category/types';
import SubCategorySection from './SubCategorySection';
import { SubCategoryDataT } from '../types';

export default function SubCategoriesSection({
  subCategories,
  handle,
}: {
  subCategories: Array<SubCategoryDataT>;
  handle: CategoryLandingPageKey;
}) {
  // Filter out subCategories with less than 6 offers
  const filteredSubCategories = subCategories.filter(
    (sub) => sub.offerCount > 5,
  );

  return (
    <>
      {filteredSubCategories.map((category) => (
        <SubCategorySection handle={handle} category={category} />
      ))}
    </>
  );
}
